/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Form from "../Form";
import Profile from "../Profile";
import Modal, { ModalHeader } from "../Modal";
import useForm from "../../hooks/useForm";
import systemAlert from "../../utils/systemAlert";
import { addCompanyPersonInCharge, editCompanyPersonInCharge } from "../../apis/admin/companies";
import { toast } from "../../utils/toast";
import { isEmpty } from "lodash";

const CareCompanyPersonInChargePost = (props) => {
  const { post, open, setOpen, submit, orgMode, managerCompany } = props
  const [mode, setMode] = useState(orgMode)
  const [fields, setFields] = useState([]);
  const [buttons, setButtons] = useState([])

  const defaultForm = {
    employee: null,
    memo: "",
    fileIdxes: "",
  }

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    resetForm(defaultForm)
  };

  const _submit = (_form) => {
    const {employee, title, memo, fileIdxes, idx: postIdx} = _form
    const form = {
      employeeIdx: employee[0].idx, title, memo, fileIdxes,
    }
    if (mode === "create") {
      systemAlert(`등록하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '등록',
            onClick: () => {
              addCompanyPersonInCharge(managerCompany.companyIdx, form)
                .then(() => {
                  toast.success(`정상적으로 등록되었습니다.`)
                  cancel()
                  if (submit) {
                    submit()
                  }
                })
            }
          }
        ]
      })
    } else if (mode === "modify") {
      systemAlert(`수정하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '수정',
            onClick: () => {
              editCompanyPersonInCharge(managerCompany.companyIdx, postIdx, form)
                .then(() => {
                  cancel()
                  if (submit) {
                    submit()
                  }
                })
            }
          }
        ]
      })
    }
    

  }

  const {
    form,
    errors,
    handleSubmit,
    handleOnChange,
    setForm,
    resetForm,
    setOriginForm,
    setValidateFields
  } = useForm(
    defaultForm,
    _submit
  );

  useEffect(() => {
    setMode(orgMode)
    if (post) {
      const form = {
        ...post,
      }
      setForm(form)
      setOriginForm(form)
    } else {
      setForm({
        ...defaultForm,
      })
      setOriginForm({
        ...defaultForm,
      })
    }
  }, [open, post, orgMode])

  useEffect(() => {
    setFields([
      [
        {
          isHide: () => mode === "create",
          title: "담당자",
          //key: "employee",
          //type: "searchemployee",
          type: 'component',
          component: () => {
            if (!isEmpty(post)) {
              return <><Profile employeeIdx={post.employeeIdx} /></>
            } else {
              return <></>
            }
          }
        },
        {
          isHide: () => mode !== "create",
          title: "담당자",
          key: "employee",
          type: "searchemployee",
          required: true,
          isSingle: true,
        },
      ],
      [
        {
          isHide: () => mode === "create",
          title: "부서",
          type: 'component',
          component: () => {    
            if (!isEmpty(post)) {
              const employee = post.employee[0]
              return !isEmpty(employee) ? post.employee[0].partName : ''
            } else {
              return <></>
            }
          }
        },
        {
          isHide: () => mode === "create",
          title: "직급",
          type: 'component',
          component: () => {    
            if (!isEmpty(post)) {
              const employee = post.employee[0]
              return !isEmpty(employee) ? post.employee[0].gradeName : ''
            } else {
              return <></>
            }
          }
        },
      ],
      [
        {
          isHide: () => mode === "create",
          title: "핸드폰",
          type: 'component',
          component: () => {    
            if (!isEmpty(post)) {
              const employee = post.employee[0]
              return !isEmpty(employee) ? post.employee[0].mobile : ''
            } else {
              return <></>
            }
          }
        },
        {
          isHide: () => mode === "create",
          title: "전화번호",
          type: 'component',
          component: () => {    
            if (!isEmpty(post)) {
              const employee = post.employee[0]
              return !isEmpty(employee) ? post.employee[0].phone : ''
            } else {
              return <></>
            }
          }
        },
      ],
      [
        {
          isHide: () => mode === "create",
          title: "이메일",
          type: 'component',
          component: () => {
            if (!isEmpty(post)) {
              const employee = post.employee[0]
              return !isEmpty(employee) ? post.employee[0].email : ''
            } else {
              return <></>
            }
          }
        },
      ],
      [
        {
          title: "메모", key: "memo", type: "textarea",
        },
      ],
      [
        {
          title: "첨부파일",
          key: "fileIdxes",
          type: "dropzone",
          required: false,
        },
      ]
    ])
  }, [mode, post])

  useEffect(() => {
    setButtons([
      {
        color: 'text',
        label: '닫기',
        onClick: cancel
      },
      {
        isHide: mode !== 'modify',
        label: '수정',
        onClick: handleSubmit
      },
      {
        isHide: mode !== 'create',
        label: '등록',
        onClick: handleSubmit
      }
    ])
  }, [mode])
  useEffect(() => {
    setValidateFields(fields)
  }, [fields])

  return (
    <Modal
      isOpen={open}
      close={cancel}
    >
      <div className="client-write">
        <ModalHeader>{post ? '담당자 상세 정보' : '담당자 정보 입력'} </ModalHeader>
        <Form
          mode={mode}
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          // submitText={mode === 'create' ? '작성' : '수정'}
          // submit={handleSubmit}
          // cancel={cancel}
          buttons={buttons}
        />
      </div>
    </Modal>
  );
};

export default CareCompanyPersonInChargePost;
